import React, { useEffect, Component } from "react";
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import { editOPA, getOPAActivity, geteditopainfo } from "../../../../actions/OPAAction";
import Autocomplete from "react-autocomplete";
import $, { extend } from "jquery"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import moment from "moment"
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import styles from "../../../../assets/jss/customStyle";
import { getlookupdocinfo } from "../../../../actions/MasterDataAction";

const useStyles = makeStyles((theme) => ({
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    error: {
        color: '#f44336',
    },
    helperText: {
        '& p': {
            marginLeft: "0px !important"
        }
    },
    inputfieldAlign: {
        "& fieldset": {
            top: "-1px !important",
        }

    }
}));

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
];

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}
class EditOPA_Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            isError: false,
            addData: {
                "Id": 0,
                "ProjectId": 0,
                "PlannedDate": "",
                "CompletionDate": null,
                "Activity": "",
                "Comments": "",
                "ReasonsForDeviation":null
            }
        }
    }
    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(getlookupdocinfo("Operation"))
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.Id = parseInt(localStorage.getItem("OPAEditId"))
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.props.dispatch(getOPAActivity())
        this.geteditopainfo(this.state.addData.Id)
        this.state.addData.Activity = this.props.geteditopa.Activity;
        this.state.addData.PlannedDate = this.props.geteditopa.PlannedDate;
        this.state.addData.CompletionDate = this.props.geteditopa.CompletionDate;
        this.state.addData.ReasonsForDeviation = this.props.geteditopa.ReasonsForDeviation;
        this.setState({})
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        $("#Operation1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Operation").addClass("d-none");
        $("#Operation").removeClass("d-block");
        $("#OPAL").removeClass("active-color");
        $("#OPAT").removeClass("fw-bolder");
    }
    geteditopainfo = (id) => {
        let apiUrl = API.OPA_LISTVIEW + '/' + id
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.props.dispatch({ type: "OPAEDIT_DOCS", data: response.data });
                    this.state.addData.Id = response.data.Id;
                    this.state.addData.Activity = response.data.Activity;
                    this.state.addData.PlannedDate = response.data.PlannedDate;
                    this.state.addData.CompletionDate = response.data.CompletionDate;
                    this.state.addData.ReasonsForDeviation = response.data.ReasonsForDeviation;
                    this.state.addData.Comments = response.data.Comments;
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    };
    resize = () => {

        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#Operation1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Operation").removeClass("d-none");
        $("#Operation").addClass("d-block");
        $("#OPAL").addClass("active-color");
        $("#OPAT").addClass("fw-bolder");
        // this.state.Error = this.props.erroropapass;
        // this.state.addData = this.props.sharedopadata;
        // this.setState({})
    };
    renderProjectNames = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };
    handleInputChange = (e, node) => {
        this.state.addData[node] = e.target.value;
        this.setState({});
        this.props.dispatch({ type: "SHARE_OPADATAS", data: this.state.addData })
    };
    handleCommentChange = (e, node) => {
        this.state.addData[node] = e.target.value;
        this.setState({});
        this.props.dispatch({ type: "SHARE_OPADATAS", data: this.state.addData })
    };

    handleDateChange = (e, node) => {
        if(e.target.value != null){
            this.state.addData[node] = e.target.value; 
        }
        else{
            this.state.addData[node] = ""
        }
        this.setState({});
        this.props.dispatch({ type: "SHARE_OPADATAS", data: this.state.addData })
    };

    handleProjectNameSearchChange = (e) => {
        this.state.addData.Activity = e.target.value;
        this.setState({});
        this.props.dispatch({ type: "SHARE_OPADATAS", data: this.state.addData })
    };

    handleProjectNameSelectChange = (e) => {
        this.state.addData.Activity = e;
        this.setState({});
        this.props.dispatch({ type: "SHARE_OPADATAS", data: this.state.addData })
    };

    render() {
        let { classes, menuToggle, OPA_Actvity } = this.props;
        return (
            <><div>
                <div style={{ margin: this.state.isMobile ? "0" : "15px 30px" }}>
                    <div className="row  mt-1">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mt-3">
                            <label>Activity :</label>
                        </div>

                        <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4 mt-3">
                            {this.props.erroropapass.ActivityError ?

                                <div className="autocomplete-wrappers">
                                    <Autocomplete
                                        contentEditable={true}
                                        value={this.state.addData.Activity}
                                        inputProps={{
                                            placeholder: "Activity",
                                        }}
                                        helperText="Required field must be filled in"
                                        classes={{ root: classes.helperText }}
                                        fullWidth
                                        items={this.props.OPA_Actvity ?? []}
                                        getItemValue={(item) => item.Name}
                                        shouldItemRender={this.renderProjectNames.bind(this)}
                                        renderMenu={(item) => (
                                            <div className="dropdowns d-block" >{item}</div>
                                        )}

                                        renderInput={(props) => {
                                            return (
                                                <input
                                                    className="form-control border-radius"
                                                    id="exampleFormControlInput1"
                                                    {...props}
                                                    error={true}
                                                    style={{ width: '100%', height: 35, fontSize: 12, color: "#000000", borderColor: 'red' }}
                                                />
                                            );
                                        }}
                                        renderItem={(item, isHighlighted) => (
                                            <div
                                                className={`items 
               ${isHighlighted ? "selected-items" : ""
                                                    }`}
                                            >
                                                {item.Name}
                                            </div>
                                        )}
                                        onChange={(e) => this.handleProjectNameSearchChange(e)}
                                        onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                    />
                                    <div className="helperText pt-1">
                                        <p style={{ color: 'red' }}> Required field must be filled in</p>
                                    </div>
                                </div> :
                                <div className="autocomplete-wrappers">
                                    <Autocomplete
                                        contentEditable={true}
                                        value={this.state.addData.Activity}
                                        inputProps={{
                                            placeholder: "Activity",

                                        }}
                                        style={{ width: '100%' }}
                                        items={this.props.OPA_Actvity ?? []}
                                        getItemValue={(item) => item.Name}
                                        shouldItemRender={this.renderProjectNames.bind(this)}
                                        renderMenu={(item) => (
                                            <div className="dropdowns d-block" >{item}</div>
                                        )}

                                        renderInput={(props) => {
                                            return (
                                                <input
                                                    className="form-control border-radius"
                                                    id="exampleFormControlInput1"
                                                    {...props}
                                                    error={true}
                                                    style={{ width: '100%', height: 35, fontSize: 12, color: "#000000" }}
                                                />
                                            );
                                        }}
                                        renderItem={(item, isHighlighted) => (
                                            <div
                                                className={`items 
         ${isHighlighted ? "selected-items" : ""
                                                    }`}
                                            >
                                                {item.Name}
                                            </div>
                                        )}
                                        onChange={(e) => this.handleProjectNameSearchChange(e)}
                                        onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                    />
                                </div>
                            }
                        </div>
                        <div className="col-12 col-sm-12 mt-3 col-md-12 col-lg-2 col-xl-2">
                            <label>Planned <label style={{ whiteSpace: 'nowrap' }}>Date :</label></label>
                        </div>

                        <div className="col-12 col-sm-12 mt-3 pb-4 col-md-12 col-lg-4 col-xl-4">
                            {this.props.erroropapass.PlannedDateError ?
                                <TextField
                                    type="date"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    error
                                    id="type-date"
                                    placeholder={moment(this.state.addData.PlannedDate).format("yyyy-MM-DD")}
                                    onChange={(e) => { this.handleDateChange(e, "PlannedDate") }}
                                    helperText="Required field must be filled in"
                                    InputProps={{
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                    classes={{ root: classes.helperText }}
                                />
                                :
                                <TextField
                                    type="date"
                                    variant="outlined"
                                    size="small"
                                    id="type-date"
                                    fullWidth
                                    placeholder={moment(this.state.addData.PlannedDate).format("yyyy-MM-DD")}
                                    onChange={(e) => { this.handleDateChange(e, "PlannedDate") }}
                                    InputProps={{
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                />
                            }
                        </div>
                        <div className="col-12 mt-3 col-sm-12 col-md-12 col-lg-2 col-xl-2">
                            <label>Date of <label style={{ whiteSpace: 'nowrap' }}>Completion :</label></label>
                        </div>

                        <div className="col-12 mt-3 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4">

                            <TextField
                                type="date"
                                variant="outlined"
                                size="small"
                                fullWidth
                                id="type-date"
                                placeholder={this.state.addData.CompletionDate && moment(this.state.addData.CompletionDate).format("yyyy-MM-DD")}
                                onChange={(e) => { this.handleDateChange(e, "CompletionDate") }}
                                InputProps={{
                                    className: `border-radius ${classes.inputfieldAlign}`
                                }}
                            />

                        </div>
                        <div className="col-12 mt-3 col-sm-12 col-md-12 col-lg-2 col-xl-2">
                            <label>Reasons for <label style={{ whiteSpace: 'nowrap' }}>Deviation :</label></label>
                        </div>

                        <div className="col-12 mt-3 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4">
                            {this.props.erroropapass.ReasonsForDeviationError ?
                                <TextField
                                    multiline
                                    rows={4}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    error
                                    value={this.state.addData.ReasonsForDeviation}
                                    onChange={(e) => { this.handleInputChange(e, "ReasonsForDeviation") }}
                                    helperText="Required field must be filled in"
                                    InputProps={{
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                    classes={{ root: classes.helperText }}
                                /> : <TextField
                                    multiline
                                    rows={4}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={this.state.addData.ReasonsForDeviation}
                                    onChange={(e) => { this.handleInputChange(e, "ReasonsForDeviation") }}
                                    InputProps={{
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                />}
                        </div>
                        <div className="col-12 mt-3 col-sm-12 col-md-12 col-lg-2 col-xl-2">
                            <label>Comments :</label>
                        </div>
                        <div className="col-12 mt-3 col-sm-12 pb-4 col-md-12 col-lg-10 col-xl-10">
                            <TextField
                                multiline
                                rows={8}
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={this.state.addData.Comments}
                                onChange={(e) => { this.handleCommentChange(e, "Comments") }}
                                InputProps={{
                                    className: `border-radius ${classes.inputfieldAlign}`
                                }}
                            />
                        </div>
                    </div>

                </div>
            </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        OPA_Actvity: state.MasterDataReducer.Lookup_data || [],
        geteditopa: state.OPAReducer.geteditopa || [],
        sharedopadata: state.OPAReducer.sharedopadata || [],
        erroropapass: state.OPAReducer.erroropapass || [],
    };
}

EditOPA_Detail.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditOPA_Detail))
);
